import(/* webpackMode: "eager", webpackExports: ["DirectoryBadgesProvider"] */ "/app/src/components/mirofish/directory-badges-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mirofish/home-page.tsx");
